import styles from "./styles.scss";
import defaultToast from "react-hot-toast";
import { CustomToast, ToastProps, ToastType } from "./types";
import { Toast } from "./components";
import clsx from "clsx";
import { TOAST_DEFAULT_DURATION } from "@/constants";

const createToast = ({ message, toastType, ...props }: ToastProps): string => {
  return defaultToast(
    toastSettings => (
      <Toast
        toastType={toastType}
        message={message}
        toastSettings={toastSettings}
        {...props}
      />
    ),
    {
      duration:
        toastType === ToastType.Loading
          ? TOAST_DEFAULT_DURATION * 1000
          : TOAST_DEFAULT_DURATION,
      className: clsx(styles.toastContainer, props.className),
      ...props,
    },
  );
};

export const toast: CustomToast = {
  success: (message, props) =>
    createToast({ ...props, message, toastType: ToastType.Success }),
  error: (message, props) =>
    createToast({ ...props, message, toastType: ToastType.Error }),
  warning: (message, props) =>
    createToast({ ...props, message, toastType: ToastType.Warning }),
  info: (message, props) =>
    createToast({ ...props, message, toastType: ToastType.Info }),
  loading: (message, props) =>
    createToast({ ...props, message, toastType: ToastType.Loading }),
  acrylic: (message, props) =>
    createToast({ ...props, message, toastType: ToastType.Acrylic }),
  default: (message, props) =>
    createToast({ ...props, message, toastType: ToastType.Default }),
  dismiss: (toastId?: string) => defaultToast.dismiss(toastId),
  remove: (toastId?: string) => defaultToast.remove(toastId),
};
